import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitDaybookMarkAllViewed = {
  user: string;
};

export const daybookMarkAllViewed = async (
  data: SubmitDaybookMarkAllViewed
) => {
  const response = await axios.post(
    `${rootUrl}/psychologist/daybook/mark/all/viewed`,
    {
      user: data.user,
      token: getCookies('auth'),
    }
  );

  return response.data;
};
